import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppAsyncThunkConfig } from 'store';
import { parseErrorData } from 'utils/service';
import { AppUser, ServiceAccount } from 'services/account';

export const actionDashboardActivities = createAsyncThunk<AppUser, void, AppAsyncThunkConfig>(
  `DASHBOARD_ACTIVITIES/getUser`,
  async () => {
    try {
      const { data: user } = await ServiceAccount.getCurrentAppUser();
      return user;
    } catch (e) {
      throw parseErrorData(e);
    }
  },
);
